import { Box, Button, Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import { AdvanceListSearch } from "./AdvanceListSearch";

export const AdvanceOrderList: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  const navigate = useNavigate();
  const [cartOpen, setCartOpen] = useState(false);

  const handleCartClick = () => {
      setCartOpen(true);
  };
  
  const handleCartClose = () => {
      setCartOpen(false);
  };
  const handleClick = (path: string) => {
    navigate(path);
  };

  const columns: IColumns[] = [
    {
      header: "Order No/ Room No",
      fieldName: "workLocationName",
      tooltip: true,
    },
    
    {
      header: "Order Date",
      fieldName: "address",
      tooltip: true,
    },
    
    {
      header: "Guset name",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Phone Number",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Deliver Date",
      fieldName: "address",
      tooltip: true,
    },
    {
        header: "Avance",
        fieldName: "address",
        tooltip: true,
    },
    {
        header: "Due Amount",
        fieldName: "address",
        tooltip: true,
    },
  ];
  
  return (
    <Grid 
      display="flex" 
      flexDirection="column" 
      minHeight="100vh" // Ensures the container occupies the full height of the viewport
    >
    <Grid container direction="column" spacing={2} p={2} flex="1">
      {/* Header and Icon Section */}
      <Grid item>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "green" }}
            >
              Advance Order List
            </Typography>
          </Grid>
          <Grid item>
            <Grid display="flex" alignItems="center">
              
              <Tooltip title="All Order">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                >
                  <WSIcons.FormatListBulletedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Ready Order">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                >
                  <WSIcons.ReadyOrder />
                </IconButton>
              </Tooltip>
              <WSDateField
                id="date"
                name="date"
                dateFormat="D/MM/YYYY"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                label={""}
              />
              <Tooltip title="Reset">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                    marginLeft: "16px",
                  }}
                >
                  <WSIcons.SyncIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Search">
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    marginRight: "8px",
                    borderRadius: "2px",
                  }}
                  onClick={handleCartClick}
                >
                  <WSIcons.SearchIcon />
                </IconButton>
              </Tooltip>
              <AdvanceListSearch open={cartOpen} onClose={handleCartClose} />

              <IconButton>
                <WSIcons.CloseIcon
                  sx={{ backgroundColor: "red", color: "white" }}
                  onClick={() => handleClick("/")}
                />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>
      </Grid>
      <Grid bgcolor="#333" p={2} display="flex" justifyContent="space-between" alignItems="center">
        <WSIcons.GTranslateIcon sx={{color:"white"}}/>
        <Grid display="flex" ml="auto" gap={4}>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>Reprint Label</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>Reprint</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>Void</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>Ready</Button>
        <Button variant="outlined" sx={{borderColor:"green",color:"white"}}>Receipt & settle</Button>
        <Button variant="contained" color="success">Recall</Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
